export default __webpack_public_path__ + "static/media/330_dummy-2014-store01-de.de00bb5c.png";